<template>
  <div>
    <van-cell-group  inset style="margin-top: 10px;padding: 10px;">
  <van-cell style="background-color: #DDEFFF" title="户主/户号" :value="`${username}/${item.consumer_no}`" />
  <van-cell title="手机号" :value="phone" />
  <van-cell title="地址/水牌号" :value="`${item.region_name}/${item.water_number}`" />
  <van-cell title="详细地址" :value="this.address" />
  <van-cell title="水表位置" :value="this.place" />
  <van-cell title="余额" :value="this.money" />
  <van-cell title="上次抄表吨" :value="this.last_ons" />
  <van-cell title="上次抄表" :value="item.lasttime" />
  <van-cell title="未抄表时间">
    <van-tag v-if="item.chaodata=='year'" type="danger">一年以上</van-tag>
    <van-tag v-else-if="item.chaodata=='banupyear'" type="warning">半年以上</van-tag>
    <van-tag v-else type="success">半年以下</van-tag>
  </van-cell>
  <van-cell title="备注" :value="item.memo" />
  <div style="margin:0px 16px 0px 16px;">
    <van-row>
  <!-- <van-col v-if="this.itemphone==''"  span="12"><van-button  type="info" size="small" block  @click="$router.push(`/records/${item.id}`)" >去抄表</van-button></van-col>
  <van-col v-if="this.itemphone!==''" span="24"><van-button  type="info" size="small" block  @click="$router.push(`/records/${item.id}`)" >去抄表</van-button></van-col>
  <van-col v-if="this.itemphone==''" span="12">  <van-button  type="primary" size="small" block  @click="sss" >修改资料</van-button></van-col> -->

  <van-col v-if="this.money!==''&&this.last_ons!==''"  span="12"><van-button  type="info" size="small" block  @click="$router.push(`/records/${item.id}`)" >去抄表</van-button></van-col>
  <van-col  span="12"> <van-button  type="primary" size="small" block  @click="sss" >修改资料</van-button></van-col>

</van-row>
<van-dialog class="rechargeList" @confirm="abc"  v-model="show" :title="this.item.username" show-cancel-button>
  <van-cell-group>
  <van-field v-model="username" label="用户名" placeholder="请输入用户名" />
  <van-field v-model="consumer_no" label="户号" placeholder="请输入户号" />
  <van-field v-model="phone" label="手机号" placeholder="请输入用户手机号" />
  <van-field v-model="water_number" label="水牌号" placeholder="请输入水牌号" />
  <van-field v-model="address" label="详细地址" placeholder="请输入详细地址" />
  <van-field v-model="place" label="水表位置" placeholder="请输入水表位置" />
  <van-field v-model="card" label="身份证" placeholder="请输入身份证号" />
  <!-- <van-field v-model="last_ons" :disabled="this.item.last_ons != 0 ? true : false" label="上次抄表吨数" placeholder="请输入上次抄表吨数" />
  <van-field v-model="money" :disabled="this.item.money != '0.00' ? true : false" label="上次抄表金额" placeholder="请输入上次抄表金额" /> -->
  <van-field v-model="last_ons" :disabled = isbool  label="上次抄表吨数" placeholder="请输入上次抄表吨数" />
  <van-field v-model="money"   :disabled = isbool  label="上次抄表金额" placeholder="请输入上次抄表金额" />
  <van-field v-model="picture" name="picture" v-show="false" />
        <van-field v-model="consumer_id" name="consumer_id" v-show="false" />
        <van-field name="uploader" label="凭证(必填)">
          <template #input>
            <van-uploader
              :after-read="afterRead"
              :before-read="beforeRead"
              v-model="uploader"
              :max-count="1"
            />
          </template>
        </van-field>
  <van-field name="switch" label="上次抄表时间为现在">
  <template #input>
    <van-switch v-model="switchChecked" size="20" />
  </template>
</van-field>
  <van-field v-model="memo" label="备注" placeholder="请输入备注" />
</van-cell-group>
</van-dialog>

</div>
</van-cell-group>

  </div>

</template>

<script>
import { consumerphone, getRole } from '@/api/consumer'
import Compressor from 'compressorjs'
import { myupload } from '@/api/common'
export default {
  name: 'ConsumerItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      consumer_id: this.item.id,
      show: false,
      phone: this.item.phone,
      address: this.item.address,
      consumer_no: this.item.consumer_no,
      username: this.item.username,
      place: this.item.place,
      water_number: this.item.water_number,
      card: this.item.card,
      money: this.item.money != null ? this.item.money : '',
      last_ons: this.item.last_ons != null ? this.item.last_ons : '',
      memo: this.item.memo,
      switchChecked: false,
      isbool: true,
      picture: '',
      uploader: []

    }
  },
  async created () {
    const { data: isbool } = await getRole()
    this.isbool = isbool
  },
  methods: {
    // dialog () {
    //   this.$dialog.confirm({
    //     title: '用主',
    //     message: this.username
    //   })
    //     .then(() => {
    //       alert(this.consumer_id)
    //     })
    //     .catch(() => {
    //       // on cancel
    //     })
    // },

    sss () {
      this.show = true
    },
    async abc () {
      const res = await consumerphone({
        consumer_id: this.item.id,
        phone: this.phone,
        address: this.address,
        place: this.place,
        consumer_no: this.consumer_no,
        username: this.username,
        water_number: this.water_number,
        card: this.card,
        money: this.money,
        last_ons: this.last_ons,
        memo: this.memo,
        switchChecked: this.switchChecked,
        picture: this.picture
      })
      if (res.code === 1) {
        // this.$router.go(0)
      //  this.money =
        // this.item.money = this.money
        // this.item.last_ons = this.last_ons
        this.$toast.success('操作成功')
      } else {
        this.show = true
        this.$toast.fail(res.msg)
      }
    },
    beforeRead (file) {
      //  console.log(file.type)
      if (file.type !== 'image/jpeg') {
        return false
      }
      //  console.log(file)
      return new Promise((resolve) => {
        /* eslint-disable no-new */

        new Compressor(file, {
          success: resolve,
          error (err) {
            console.log(err.message)
          }
        })
      })
    },

    async afterRead (file) {
      const _this = this
      // console.log(file)
      file.status = 'uploading'
      file.message = '上传中...'
      /* eslint-disable no-new */
      new Compressor(file.file, {
        quality: 0.1,

        async success (resul) {
          const params = new FormData()
          // console.log(result)
          params.append('file', resul, resul.name)

          const myup = await myupload(params)
          //  console.log(params)
          console.log(myup)
          // console.log(myup.code)
          // result.status = 'done'
          // result.message = '上传成功'

          if (myup.code === 1) {
            //  console.log('sdfsfsdsdfsdfsdf')
            file.status = 'done'
            file.message = '上传成功'

            _this.picture = myup.data.url
            // console.log(this.picture)
          } else if (myup.code === 0) {
            file.status = 'failed'
            file.message = '上传失败'
          }
        },
        error (err) {
          console.log(err)
        }
      })
    }
  }
}
</script>

<style >
.van-cell__value{
flex: 2;
}

.rechargeList{
  height: 90%;
  overflow: scroll;
}

</style>
